export var AI_CHAT_ACCOUNTING_SUBSCRIPTION_REPOSITORY = 'AI_CHAT_ACCOUNTING_SUBSCRIPTION_REPOSITORY';